module.exports = __webpack_public_path__ + "mz.aff3b04a.svg";